/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import PhClock from 'ember-phosphor-icons/components/ph-clock';
import PhCheckCircle from 'ember-phosphor-icons/components/ph-check-circle';
import PhXCircle from 'ember-phosphor-icons/components/ph-x-circle';
import { BookingRentalAgreementStatus } from 'uplisting-frontend/models/booking-rental-agreement';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  rentalAgreement: ModelRegistry['booking-rental-agreement'];
}

export interface BookingStatusRentalAgreementSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingStatusRentalAgreementComponent extends Component<BookingStatusRentalAgreementSignature> {
  @cached
  get rentalAgreement(): ModelRegistry['booking-rental-agreement'] {
    return this.args.rentalAgreement;
  }

  @cached
  get status(): BookingRentalAgreementStatus {
    return this.rentalAgreement.status;
  }

  @cached
  get showLink(): boolean {
    return this.status === BookingRentalAgreementStatus.processed;
  }

  @cached
  get alertClass():
    | 'inline-alert-danger'
    | 'inline-alert-processing'
    | 'inline-alert-success' {
    switch (this.status) {
      case BookingRentalAgreementStatus.pending:
        return 'inline-alert-danger';
      case BookingRentalAgreementStatus.processing:
      case BookingRentalAgreementStatus.markedAsSigned:
        return 'inline-alert-processing';
      case BookingRentalAgreementStatus.processed:
        return 'inline-alert-success';
    }
  }

  @cached
  get iconComponent():
    | typeof PhXCircle
    | typeof PhCheckCircle
    | typeof PhClock
    | undefined {
    switch (this.status) {
      case BookingRentalAgreementStatus.pending:
        return PhXCircle;
      case BookingRentalAgreementStatus.processing:
        return PhClock;
      case BookingRentalAgreementStatus.processed:
      case BookingRentalAgreementStatus.markedAsSigned:
        return PhCheckCircle;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Status::RentalAgreement': typeof UiBookingStatusRentalAgreementComponent;
  }
}
